import { render, staticRenderFns } from "./AutocompleteInput.vue?vue&type=template&id=b3897556&scoped=true"
import script from "./AutocompleteInput.vue?vue&type=script&lang=js"
export * from "./AutocompleteInput.vue?vue&type=script&lang=js"
import style0 from "./AutocompleteInput.vue?vue&type=style&index=0&id=b3897556&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3897556",
  null
  
)

export default component.exports